
import { Component, Vue } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import { GlobalOverlayConfig } from '@/ts/interfaces/OverlayInterfaces';

@Component
export default class GlobalOverlayMethods extends Vue {
    get globalOverlayConfig(): GlobalOverlayConfig {
        return this.$store.getters['GlobalOverlay/getGlobalOverlayConfig'];
    }

    public openGlobalOverlay(config: GlobalOverlayConfig) {
        this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_CONFIG, config)
            .then(() => {
                this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_VISIBILITY, true);
            });
    }

    public closeGlobalOverlay(): void {
        this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_CONFIG, {})
            .then(() => {
                this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_VISIBILITY, false);
            });
    }
}
